import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

// Metric help texts in pt-BR
export const METRIC_HELP_TEXTS = {
  bounce_rate: "Percentual de sessões em que o usuário não teve engajamento significativo e saiu rapidamente do site. Baseado na métrica de 'bounce rate' do GA4.",
  conversion_rate: "Percentual de usuários que realizaram pelo menos uma conversão no período selecionado (por exemplo, purchase, generate_lead ou sign_up), com base no evento de conversão configurado para este projeto.",
  new_users: "Quantidade de usuários que acessaram o site pela primeira vez no período selecionado, de acordo com o GA4.",
  sessions: "Número total de sessões iniciadas no período selecionado. Uma sessão representa um grupo de interações de um usuário em um intervalo de tempo.",
  users: "Número de usuários únicos que tiveram pelo menos uma sessão no período selecionado.",
  engagement_rate: "Percentual de sessões consideradas engajadas pelo GA4 (por exemplo, sessões com duração mínima, mais de uma visualização de página ou pelo menos uma conversão).",
  avg_engagement_time: "Tempo médio em que os usuários permaneceram ativamente engajados com o site durante o período selecionado.",
  total_purchases: "Quantidade total de compras/conversões realizadas no período selecionado, com base no evento de conversão configurado para o projeto.",
  total_revenue: "Receita total gerada pelas vendas no período selecionado. Baseado na métrica purchaseRevenue do GA4."
};

const MetricHelpIcon = ({ metricKey, className = '' }) => {
  const helpText = METRIC_HELP_TEXTS[metricKey];
  
  if (!helpText) return null;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={`inline-flex items-center justify-center rounded-full hover:bg-muted/50 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 ${className}`}
            aria-label={`Ajuda sobre ${metricKey}`}
          >
            <HelpCircle className="h-4 w-4 text-muted-foreground hover:text-foreground transition-colors" />
          </button>
        </TooltipTrigger>
        <TooltipContent 
          side="top" 
          className="max-w-xs bg-popover text-popover-foreground border shadow-md p-3"
          sideOffset={5}
        >
          <p className="text-sm leading-relaxed">{helpText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default MetricHelpIcon;
